import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, VENDOR_SLUGS, vendorLabel } from "../lib/api";
import ProductCard from "../components/ProductCard";

const FILTERS = [{ slug: "all", label: "All" }, ...VENDOR_SLUGS.map((s) => ({ slug: s, label: vendorLabel(s) }))];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const active = params.get("v") || "all";
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const r = await api.get("/products");
      setItems(r.data);
    })();
  }, []);

  const filtered = active === "all" ? items : items.filter((p) => p.vendor === active);

  return (
    <div data-testid="catalog-page" className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="overline mb-3">The catalog</div>
      <h1 className="font-serif italic text-5xl md:text-6xl tracking-tight">Everything in stock.</h1>
      <p className="text-white/50 max-w-xl mt-4">
        {filtered.length} pieces · across nine houses. Filter by vendor below.
      </p>

      <div className="mt-12 flex flex-wrap gap-2 border-b border-white/10 pb-6">
        {FILTERS.map((v) => (
          <button
            key={v.slug}
            type="button"
            data-testid={`filter-${v.slug}`}
            onClick={() => setParams(v.slug === "all" ? {} : { v: v.slug })}
            className={`px-4 py-2 text-xs uppercase tracking-[0.22em] border ${
              active === v.slug
                ? "bg-white text-black border-white"
                : "border-white/15 text-white/60 hover:text-white hover:border-white/40"
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12">
        {filtered.map((p, i) => (
          <ProductCard key={p.id} product={p} idx={i} />
        ))}
      </div>
    </div>
  );
}
